import { render, staticRenderFns } from "./accountActivation.vue?vue&type=template&id=2621f8de&scoped=true"
import script from "./accountActivation.vue?vue&type=script&lang=ts"
export * from "./accountActivation.vue?vue&type=script&lang=ts"
import style0 from "./accountActivation.vue?vue&type=style&index=0&id=2621f8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621f8de",
  null
  
)

export default component.exports